import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || "/dashboard/events";

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) {
      navigate(from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <AuthLayout testid="login-page" quote="Welcome back. Your next sold-out event starts here.">
      <div className="gt-label mb-3">Organiser sign in</div>
      <h2 className="font-heading text-4xl font-black tracking-tighter mb-2">Log in to Getickets</h2>
      <p className="text-[var(--gt-ink-2)] text-sm mb-8">
        Don&apos;t have an account?{" "}
        <Link to="/signup" className="text-[var(--gt-ink)] font-semibold underline underline-offset-4 hover:text-[var(--gt-accent)]" data-testid="link-to-signup">
          Sign up
        </Link>
      </p>

      <form onSubmit={onSubmit} className="flex flex-col gap-5" data-testid="login-form">
        <div>
          <label className="gt-form-label" htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            className="gt-input"
            placeholder="you@yourvenue.com.au"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="login-email-input"
          />
        </div>
        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="gt-form-label !mb-0" htmlFor="password">Password</label>
            <Link
              to="/forgot-password"
              className="text-xs text-[var(--gt-ink-2)] hover:text-[var(--gt-ink)] underline underline-offset-4"
              data-testid="link-forgot-password"
            >
              Forgot?
            </Link>
          </div>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            className="gt-input"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="login-password-input"
          />
        </div>

        {error && (
          <div className="text-sm text-[var(--gt-accent)] font-medium" data-testid="login-error">
            {error}
          </div>
        )}

        <button
          type="submit"
          className="gt-btn-primary mt-2"
          disabled={loading}
          data-testid="login-submit-btn"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          Log in
        </button>
      </form>
    </AuthLayout>
  );
}
